module.exports = __webpack_public_path__ + "img/anm2.a30135f2.png";